import base64 from 'base-64';


export function getUser(password, users) {
	var user;

	console.log('🔐 Login attempt with password:', password);

	const pw = encodeURIComponent(password.toUpperCase()).replace(/%([0-9A-F]{2})/g, function(match, p1) {
            return String.fromCharCode('0x' + p1);
    });

    var base64Pw = base64.encode(pw)

	console.log('🔑 Encoded password:', pw);
	console.log('🔒 Base64 password:', base64Pw);
	console.log('👥 Available users:', users.map(u => ({
		season: u.season,
		episode: u.episode,
		pw: u.pw
	})));

	for (user of users) {
		console.log(`Comparing "${base64Pw}" === "${user.pw}"`, base64Pw === user.pw);
		if(base64Pw === user.pw) {
			console.log('✅ Match found!', user);
			return user
		}
		/*
		if(user.pw.toLowerCase() === password.toLowerCase()){
			return user
		}*/
	}
	console.log('❌ No match found');
	return null;
}

export function getSeasonUserFromPw(password, users){
	var user;
	for (user of users) {
		if(user.pw.toLowerCase() === password.toLowerCase()){
			return user
		}
	}
	return null;
}

export function doesSeasonPasswordExist(pw, users){
	var user;
	for (user of users) {
		if(user.pw.toLowerCase() === pw.toLowerCase()){
			return true
		}
	}
	return false;

}

export function getGetChildrenFromFolder(parentId, icons) {
	var childrens = [];
	var icon;
	for (icon of icons) {
		if(icon.parent === parentId){
			childrens.push(icon);
		}
	}
	return childrens;
}